module.exports = __webpack_public_path__ + "static/media/clasesUX-2.24062c89.jpg";